import { PAYMENT_TYPES } from 'go-modules/payment-panel/payment-panel.controller';

export class SubtotalDetailsController {

	//bindings
	public subtotal;
	public showTaxExempt = false;
	public PAYMENT_TYPES = PAYMENT_TYPES;

	/* @ngInject */
	constructor () {}
}
